var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69798 2.31738L1.70038 8.31638L5.68478 12.3008L11.6831 6.30248L7.69798 2.31738Z",
    fill: "#228EC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6724 5.31289L13.1764 4.80959C14.2747 3.71059 14.2747 1.92349 13.1757 0.823786C12.0774 -0.274514 10.2896 -0.274514 9.19065 0.823786L8.68805 1.32779L12.6724 5.31289Z",
    fill: "#228EC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48029 13.0761L0.871088 13.9784C0.632388 14.0372 0.380388 13.9672 0.206788 13.7936C0.0324879 13.62 -0.0368121 13.368 0.0226879 13.1293L0.924288 9.52014L4.48029 13.0761Z",
    fill: "#228EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2f5401733b4d0da6b08ec451a010d010.svg";
export { ForwardRef as ReactComponent };